import {GetStaticProps} from 'next/types';
import {dehydrate, QueryClient} from '@tanstack/react-query';

import {useTranslate} from '@eksab/i18n';
import {useAppSettingsQuery} from '@eksab/hooks/useAppSettingsQuery';
import {useRegionSettings} from '@eksab/hooks/useRegionSettings';

import {Landing} from '@eksab/features/home/landing/Landing';
import {MobileNav, RemoveAppFooter, RemoveAppHeader} from '@eksab/components';

export default function Home() {
  const t = useTranslate();

  return (
    <>
      <Landing />
      <RemoveAppHeader />
      <RemoveAppFooter />
      <MobileNav />
    </>
  );
}

export const getStaticProps: GetStaticProps = async ({locale}) => {
  try {
    const queryClient = new QueryClient();

    await Promise.all([
      queryClient.prefetchQuery([useRegionSettings.queryKey, locale], useRegionSettings.queryFn),
      queryClient.prefetchQuery([...useAppSettingsQuery.queryKey, locale], useAppSettingsQuery.queryFn),
    ]);

    return {
      props: {
        dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
      },
      revalidate: 60 * 60 * 1,
    };
  } catch (e) {
    return {props: {}, revalidate: 60};
  }
};
